import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import { useRef } from 'react';

import { SkillsEditor } from 'src/components/Skills/SkillsEditor';
import { SkillsList } from 'src/components/Skills/SkillsList';
import { useSkills } from 'src/components/Skills/hooks/useSkills';
import {
  EditorDrawer,
  EditorDrawerProvider,
} from 'src/ui/EditorDrawer/EditorDrawer';

import translations from './.vocab';

const Skills = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { skills } = useSkills();

  const { t } = useTranslations(translations);

  return (
    <EditorDrawerProvider name="skills">
      <Box ref={scrollRef} data={{ automation: 'skill-section' }}>
        <SkillsList skills={skills} />
        <EditorDrawer
          title={t('Edit skills')}
          name="skills"
          onClose={() =>
            scrollRef.current?.scrollIntoView({ behavior: 'smooth' })
          }
        >
          <SkillsEditor skills={skills} />
        </EditorDrawer>
      </Box>
    </EditorDrawerProvider>
  );
};

export default Skills;
